/* ---------------------------------------------------------------------------
   Muro de la newsletter: rejilla MASONRY con tarjetas CHROMA + lector en la
   propia pagina.

   Los dos recursos vienen de ReactBits y van portados a JS puro (sin React ni
   GSAP): reactbits.dev/components/masonry y reactbits.dev/components/chroma-grid.
     - Masonry: cada tarjeta cae en la columna mas corta; al cambiar el ancho
       (o al llegar la proporcion real de una foto) se recolocan con transicion
       CSS, que hace de FLIP. Entrada con desenfoque desde abajo.
     - ChromaGrid: foco radial que sigue al puntero dentro de cada tarjeta y una
       capa sobre la rejilla (backdrop-filter + mascara radial) que apaga todo
       menos el circulo donde esta el raton.

   Los datos van en <script type="application/json" id="nl-posts"> (snippet
   substack-wall.liquid, generado automaticamente por el cron).
   --------------------------------------------------------------------------- */
(function () {
  var el = document.getElementById('nl-posts');
  if (!el) return;
  var posts = [];
  try { posts = JSON.parse(el.textContent || '[]'); } catch (e) { return; }
  if (!posts.length) return;

  var app    = document.getElementById('nl-app');
  var grid   = document.getElementById('nl-grid');
  var pager  = document.getElementById('nl-pager');
  var reader = document.getElementById('nl-reader');
  if (!app || !grid || !pager || !reader) return;

  var mq = window.matchMedia('(max-width: 640px)');
  var HUECO = 18;                                   /* hueco entre tarjetas */
  var ENTRADA = { y: 130, delay: 50 };              /* entrada desde abajo */
  var QUIETO = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* fondos y bordes de las tarjetas, con la paleta de la web */
  var GRAD = [
    'linear-gradient(155deg,#123338 0%,#0b0d10 78%)',
    'linear-gradient(205deg,#1d4a52 0%,#0b0d10 80%)',
    'linear-gradient(165deg,#0b0d10 0%,#234e56 100%)',
    'linear-gradient(200deg,#17323a 0%,#0d1013 82%)',
    'linear-gradient(140deg,#2e6e77 0%,#0b0d10 85%)',
    'linear-gradient(215deg,#101820 0%,#194046 90%)'
  ];
  var BORDE = ['rgba(79,154,164,.55)', 'rgba(46,110,119,.6)', 'rgba(140,168,175,.45)'];

  function porPagina() { return mq.matches ? 6 : 12; }
  function param(k) { return new URLSearchParams(location.search).get(k); }
  function ponUrl(obj, push) {
    var u = new URL(location.href);
    for (var k in obj) { obj[k] ? u.searchParams.set(k, obj[k]) : u.searchParams.delete(k); }
    (push ? history.pushState : history.replaceState).call(history, {}, '', u);
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = (s == null ? '' : s);
    return d.innerHTML;
  }
  function busca(slug) {
    for (var i = 0; i < posts.length; i++) { if (posts[i].u === slug) return posts[i]; }
    return null;
  }
  function columnas() {
    var w = grid.clientWidth || grid.parentNode.clientWidth || window.innerWidth;
    if (w >= 1560) return 6;
    if (w >= 1240) return 5;
    if (w >= 960) return 4;
    if (w >= 700) return 3;
    if (w >= 470) return 2;
    return 1;
  }

  /* ------------------------------ tarjetas ------------------------------- */
  function tarjeta(p, k) {
    var g = GRAD[k % GRAD.length], b = BORDE[k % BORDE.length];
    return '<article class="chroma-card" data-a="' + esc(p.u) + '" tabindex="0"' +
      ' style="--card-gradient:' + g + ';--card-border:' + b + '">' +
      (p.i
        ? '<span class="cc-img"><img src="' + esc(p.i) + '" alt="' + esc(p.t) + '"' +
          ' decoding="async"' + (k < 4 ? ' fetchpriority="high"' : ' loading="lazy"') + '></span>'
        : '<span class="cc-img cc-img--vacia" aria-hidden="true"><i></i></span>') +
      '<div class="cc-b">' +
        '<span class="cc-meta">' + esc(p.d) + '</span>' +
        '<h3>' + esc(p.t) + '</h3>' +
        (p.e ? '<p>' + esc(p.e) + '</p>' : '') +
        '<span class="cc-leer">Leer artículo <span class="aro">→</span></span>' +
      '</div></article>';
  }

  /* ------------------------------- masonry ------------------------------- */
  var tarjetas = [];

  function coloca(desplazamiento) {
    if (!tarjetas.length) return;
    var cols = columnas();
    var ancho = grid.clientWidth || grid.parentNode.clientWidth || window.innerWidth;
    var cw = Math.max(150, Math.floor((ancho - HUECO * (cols - 1)) / cols));
    var alturas = [];
    for (var i = 0; i < cols; i++) alturas.push(0);
    tarjetas.forEach(function (c) {
      if (parseInt(c.style.width, 10) !== cw) c.style.width = cw + 'px';
    });
    var desfase = desplazamiento || 0;
    tarjetas.forEach(function (c) {
      var col = 0;
      for (var j = 1; j < cols; j++) { if (alturas[j] < alturas[col] - 0.5) col = j; }
      var x = col * (cw + HUECO);
      var y = alturas[col];
      var alto = c.offsetHeight;
      alturas[col] = y + alto + HUECO;
      c.style.transform = 'translate3d(' + x + 'px,' + (y + desfase) + 'px,0)';
      c.dataset.col = col;
    });
    grid.style.height = Math.max(0, Math.max.apply(null, alturas) - HUECO) + 'px';
  }

  function monta(trozo) {
    grid.innerHTML = trozo.map(tarjeta).join('') +
      '<div class="chroma-overlay" aria-hidden="true"></div>' +
      '<div class="chroma-fade" aria-hidden="true"></div>';
    tarjetas = [].slice.call(grid.querySelectorAll('.chroma-card'));
    grid.classList.remove('activo');
    primero = true;

    tarjetas.forEach(function (c, k) {
      c.style.transitionDelay = QUIETO ? '0ms' : (ENTRADA.delay * Math.min(k, 10)) + 'ms';
    });

    /* proporcion real de cada foto: manda en el alto de la tarjeta */
    tarjetas.forEach(function (c, k) {
      var p = trozo[k];
      if (!p.i) { c.style.setProperty('--ar', '1.15'); return; }
      var im = new Image(), hecho = false;
      var fin = function () {
        if (hecho) return;
        hecho = true;
        if (im.naturalWidth && im.naturalHeight) {
          c.style.setProperty('--ar', (im.naturalWidth / im.naturalHeight).toFixed(3));
        }
        coloca(0);                       /* recolocacion suave (FLIP) */
      };
      im.onload = fin;
      im.onerror = fin;
      im.src = p.i;
    });

    coloca(ENTRADA.y);                   /* primera pasada: todo 130 px abajo */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        tarjetas.forEach(function (c) { c.classList.add('in'); });
        coloca(0);                       /* a su sitio: la transicion hace el resto */
      });
    });
  }

  /* ------------------------------ la lista ------------------------------- */
  function pintaLista(n) {
    /* TODOS los articulos en la misma pagina: sin paginacion (pedido del autor) */
    monta(posts);
    pager.innerHTML = '';
    pager.hidden = true;
  }

  /* ------------------------------- lector -------------------------------- */
  function pintaLector(p) {
    var html = '';
    html += '<div class="nl-reader__meta"><span class="vendor date">' + esc(p.d) + '</span><span class="nl-reader__top">' +
            '<a href="#" data-home="1">← Todos los artículos</a></span></div>';
    html += '<div class="kicker nl-reader__kicker">La travesía infinita</div>';
    html += '<h1>' + esc(p.t) + '</h1>';
    html += '<div class="nl-cuerpo">' + (p.b || '<p>' + esc(p.e) + '</p>') + '</div>';
    html += '<div class="nl-cta"><a class="pill" href="#suscribirse" data-sub="1">Suscribirme a la newsletter <span class="aro">→</span></a>' +
            '<a class="nl-back" href="#" data-home="1">← Volver a todos los artículos</a></div>';
    reader.innerHTML = html;
    reader.hidden = false;
    grid.hidden = true;
    pager.hidden = true;
    document.body.classList.add('nl-reading');
    document.title = p.t + ' — La travesía infinita';
  }

  function cierraLector() {
    reader.hidden = true;
    reader.innerHTML = '';
    grid.hidden = false;
    document.body.classList.remove('nl-reading');
    if (tituloBase) document.title = tituloBase;
  }

  function irAlBloque(suave) {
    var h = document.querySelector('header');
    var off = (h ? h.getBoundingClientRect().height : 90) + 14;
    var y = app.getBoundingClientRect().top + window.scrollY - off;
    window.scrollTo({ top: Math.max(0, y), behavior: suave ? 'smooth' : 'auto' });
  }
  function irAlBloqueDoble(suave) {
    irAlBloque(suave);
    setTimeout(function () { irAlBloque(false); }, 260);
  }

  var tituloBase = document.title;

  function pinta(push) {
    var slug = param('a');
    var p = slug ? busca(slug) : null;
    if (p) {
      pintaLector(p);
      if (push) { irAlBloqueDoble(true); } else { irAlBloqueDoble(false); }
      return;
    }
    cierraLector();
    var n = parseInt(param('p') || '1', 10); if (!n || n < 1) n = 1;
    pintaLista(n);
    if (push) { irAlBloque(true); }
  }

  /* ------------------------ efectos de la rejilla ------------------------- */
  var raton = { x: 0, y: 0 }, suave = { x: 0, y: 0 }, raf = 0, primero = true;

  function paso() {
    suave.x += (raton.x - suave.x) * 0.18;
    suave.y += (raton.y - suave.y) * 0.18;
    grid.style.setProperty('--x', suave.x.toFixed(1) + 'px');
    grid.style.setProperty('--y', suave.y.toFixed(1) + 'px');
    raf = (Math.abs(raton.x - suave.x) > 0.5 || Math.abs(raton.y - suave.y) > 0.5)
      ? requestAnimationFrame(paso) : 0;
  }

  grid.addEventListener('pointermove', function (e) {
    var r = grid.getBoundingClientRect();
    var x = e.clientX - r.left, y = e.clientY - r.top;
    if (primero) { suave.x = raton.x = x; suave.y = raton.y = y; primero = false; }
    raton.x = x; raton.y = y;
    grid.classList.add('activo');
    if (!raf) raf = requestAnimationFrame(paso);
    var t = e.target && e.target.closest ? e.target.closest('.chroma-card') : null;
    if (t) {
      var rt = t.getBoundingClientRect();
      t.style.setProperty('--mouse-x', (e.clientX - rt.left) + 'px');
      t.style.setProperty('--mouse-y', (e.clientY - rt.top) + 'px');
    }
  }, { passive: true });

  grid.addEventListener('pointerleave', function () { grid.classList.remove('activo'); });

  /* al cambiar el ancho, recoloque tipo FLIP */
  var ultimoAncho = 0, remide = 0;
  function alRedimensionar() {
    if (grid.hidden) return;
    clearTimeout(remide);
    remide = setTimeout(function () {
      var w = grid.clientWidth;
      if (!w || Math.abs(w - ultimoAncho) < 4) { ultimoAncho = w; return; }
      ultimoAncho = w;
      coloca(0);
    }, 90);
  }
  window.addEventListener('resize', alRedimensionar);
  window.addEventListener('orientationchange', alRedimensionar);

  /* ------------------------------ eventos -------------------------------- */
  document.addEventListener('click', function (e) {
    var closest = e.target.closest ? e.target.closest.bind(e.target) : null;
    if (!closest) return;
    var sub = closest('[data-sub]');
    if (sub) {
      e.preventDefault();
      document.body.classList.remove('nl-reading');
      var b = document.getElementById('suscribirse');
      if (b) {
        setTimeout(function () {
          var h = document.querySelector('header');
          var off = (h ? h.getBoundingClientRect().height : 90) + 14;
          window.scrollTo({ top: Math.max(0, b.getBoundingClientRect().top + window.scrollY - off), behavior: 'smooth' });
        }, 60);
      }
      return;
    }
    var t = closest('[data-a],[data-p],[data-home]');
    if (!t) return;
    if (t.hasAttribute('data-a')) {
      e.preventDefault();
      ponUrl({ a: t.getAttribute('data-a'), p: null }, true);
      pinta(true);
    } else if (t.hasAttribute('data-p')) {
      e.preventDefault();
      if (t.getAttribute('aria-disabled')) return;
      ponUrl({ p: t.getAttribute('data-p'), a: null }, true);
      pinta(true);
    } else if (t.hasAttribute('data-home')) {
      e.preventDefault();
      ponUrl({ a: null }, true);
      pinta(true);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !reader.hidden) { ponUrl({ a: null }, true); pinta(true); return; }
    if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.getAttribute && e.target.getAttribute('data-a')) {
      e.preventDefault();
      ponUrl({ a: e.target.getAttribute('data-a'), p: null }, true);
      pinta(true);
    }
  });
  window.addEventListener('popstate', function () { pinta(false); });
  if (mq.addEventListener) { mq.addEventListener('change', function () { pinta(false); }); }

  pinta(false);
})();
